/**
 * Rótulos do plano preventivo — uma fonte só para a tela web, o portal e o
 * fechamento da O.S.
 */
import type { MaintenancePlanRowDto, MaintenancePlanStatusDto } from "@bi/types";
import { fmtNumber } from "../../lib/format";

export const PLAN_STATUS: Record<MaintenancePlanStatusDto, { label: string; badge: string }> = {
  vencido: { label: "Vencido", badge: "badge-red" },
  vencendo: { label: "Próximo", badge: "badge-amber" },
  km_inconsistente: { label: "KM inconsistente", badge: "badge-amber" },
  sem_km: { label: "Sem KM", badge: "badge-gray" },
  sem_base: { label: "Sem base", badge: "badge-gray" },
  em_dia: { label: "Em dia", badge: "badge-green" },
};

export const PLAN_STATUS_ORDER: MaintenancePlanStatusDto[] = ["vencido", "vencendo", "km_inconsistente", "sem_km", "sem_base", "em_dia"];

export const PLAN_SOURCE_LABEL: Record<MaintenancePlanRowDto["source"], string> = {
  erp: "ERP",
  padrao: "Padrão",
  manual: "Ajustado",
  grupo: "Grupo",
};

export const EXECUTION_SOURCE_LABEL: Record<NonNullable<MaintenancePlanRowDto["lastExecution"]>["source"], string> = {
  work_order: "O.S.",
  manual: "registro manual",
  erp_adotado: "adotada do ERP",
};

export function PlanStatusBadge({ status }: { status: MaintenancePlanStatusDto }) {
  return <span className={PLAN_STATUS[status].badge}>{PLAN_STATUS[status].label}</span>;
}

/** "a cada 40.000 km", "a cada 60 dias", "a cada 40.000 km ou 180 dias". */
export function intervalText(r: Pick<MaintenancePlanRowDto, "intervalKm" | "intervalDays">): string {
  const partes = [r.intervalKm ? `${fmtNumber(r.intervalKm)} km` : null, r.intervalDays ? `${r.intervalDays} dias` : null].filter(Boolean);
  return partes.length ? `a cada ${partes.join(" ou ")}` : "—";
}

export const fmtDay = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" }) : "—";
